import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import MemoryGame from './components/examples/MemoryGame';
import TodoApp from './components/examples/TodoApp';
import WeatherDashboard from './components/examples/WeatherDashboard';
import EcommerceDashboard from './components/examples/EcommerceDashboard';
import SocialMediaFeed from './components/examples/SocialMediaFeed';
import ProjectManager from './components/examples/ProjectManager';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/memory-game/*" element={<MemoryGame />} />
          <Route path="/todo-app/*" element={<TodoApp />} />
          <Route path="/weather-dashboard/*" element={<WeatherDashboard />} />
          <Route path="/ecommerce-dashboard/*" element={<EcommerceDashboard />} />
          <Route path="/social-platform/*" element={<SocialMediaFeed />} />
          <Route path="/project-manager/*" element={<ProjectManager />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
